<template>
  <g>
    <path
      d="M23.9113 27.5527H8.37698C7.40206 27.5527 6.61108 26.7618 6.61108 25.7868V14.6304C6.61108 14.1246 7.02497 13.7107 7.53082 13.7107C8.03668 13.7107 8.45056 14.1246 8.45056 14.6304V25.7133H23.847V14.6304C23.847 14.1246 24.2608 13.7107 24.7667 13.7107C25.2726 13.7107 25.6864 14.1246 25.6864 14.6304V25.7868C25.6772 26.7618 24.8863 27.5527 23.9113 27.5527Z"
      :fill="iconColor"
    />
    <path
      d="M25.1807 15.2622H7.09866C6.12374 15.2622 5.33276 14.4712 5.33276 13.4963V11.9419C5.33276 10.967 6.12374 10.176 7.09866 10.176H25.1807C26.1556 10.176 26.9466 10.967 26.9466 11.9419V13.4963C26.9466 14.462 26.1556 15.2622 25.1807 15.2622ZM7.17224 13.4227H25.1071V12.0155H7.17224V13.4227Z"
      :fill="iconColor"
    />
    <path
      d="M13.5642 26.5213C13.5642 26.8893 13.856 27.1812 14.224 27.1812C14.5802 27.1812 14.8839 26.8919 14.8839 26.5213V11.0421C14.8839 10.6742 14.592 10.3823 14.224 10.3823C13.856 10.3823 13.5642 10.6742 13.5642 11.0421V26.5213Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.4"
    />
    <path
      d="M17.4011 26.5213C17.4011 26.8893 17.693 27.1812 18.0609 27.1812C18.4171 27.1812 18.7208 26.8919 18.7208 26.5213V11.0421C18.7208 10.6742 18.4289 10.3823 18.0609 10.3823C17.693 10.3823 17.4011 10.6742 17.4011 11.0421V26.5213Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.4"
    />
    <path
      d="M14.3457 11.5495C12.2487 11.5495 10.8231 11.1816 10.0965 10.4642C8.68011 9.04781 8.67092 6.73007 10.0965 5.30448C11.4761 3.92487 13.8766 3.92487 15.2562 5.30448C16.5531 6.60131 16.3599 9.99514 16.3047 10.6665C16.2679 11.1172 15.9092 11.4759 15.4586 11.5127C15.4678 11.5127 14.9987 11.5495 14.3457 11.5495ZM12.681 6.07707C12.1935 6.07707 11.7428 6.26102 11.4025 6.61052C10.7035 7.31872 10.7035 8.45919 11.4025 9.16739C11.6509 9.41572 12.5798 9.71003 14.3457 9.71003C14.4009 9.71003 14.4561 9.71003 14.502 9.71003C14.5204 8.37641 14.3273 6.98761 13.9502 6.61052C13.6191 6.27022 13.1684 6.07707 12.681 6.07707Z"
      :fill="iconColor"
    />
    <path
      d="M17.9326 11.5495C17.2796 11.5495 16.8197 11.5127 16.8197 11.5127C16.369 11.4759 16.0103 11.1172 15.9735 10.6665C15.9184 9.99514 15.7252 6.61051 17.022 5.30448C18.4016 3.92487 20.8022 3.92487 22.1818 5.30448C22.8716 5.99428 23.2487 6.90483 23.2487 7.87975C23.2487 8.85467 22.8716 9.77441 22.1818 10.455C21.4552 11.1908 20.0296 11.5495 17.9326 11.5495ZM17.767 9.71003C17.8222 9.71003 17.8774 9.71003 17.9234 9.71003C19.6985 9.71003 20.6182 9.41572 20.8665 9.16739C21.2068 8.82708 21.3908 8.37641 21.3908 7.88895C21.3908 7.40149 21.2068 6.95082 20.8665 6.61052C20.1859 5.92991 18.9903 5.92991 18.3097 6.61052C17.9142 7.0152 17.7578 8.46838 17.767 9.71003Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
